/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/void-dom-elements-no-children */
/* eslint-disable no-empty */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-did-update-set-state */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
import queryString from 'query-string';
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { Link } from 'react-router-dom';

import { faHeart as faRegularStar } from '@fortawesome/free-regular-svg-icons';
import { faHeart as faSolidStar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from 'react-tippy';
import { cartAddItem, cartAddItemCache } from '../../app/store/actions/cart';
import { favoritesRemoveItem, setProductsFavorites } from '../../app/store/actions/favorites';

import ProductsUtil from '../../app/utils/products';

import tagManager from '../../app/services/tagManager';
import NumberHelper from '../../helpers/number';
import validator from '../../helpers/validators';
import FinalPriceComponent from '../price/FinalPrice';
import AddToCartComponent from './AddToCartComponent';

class ProductItem extends React.PureComponent {
  constructor(props) {
    super(props);
    this.IconFavorite = {
      faSolidStar,
      faRegularStar,
    };
    this.state = {
      amount: 1,
      multipleQuantity: 1,
    };
  }

  async componentDidMount() {
    this.updateInterval = setTimeout(this.updatePromotionCoutdown, 1000);
    const { product = {} } = this.props;
    const { multipleQuantity } = this.state;
    if (product && (product.multipleQuantity !== multipleQuantity)) {
      this.setState({
        multipleQuantity: product.multipleQuantity,
        amount: product.multipleQuantity,
      });
    }
  }

  componentWillUnmount() {
    clearTimeout(this.updateInterval);
  }

  componentDidUpdate = async () => {
    const { product = {} } = this.props;
    const { multipleQuantity } = this.state;
    if (product && (product.multipleQuantity !== multipleQuantity)) {
      this.setState({
        multipleQuantity: product.multipleQuantity,
        amount: product.multipleQuantity,
      });
    }

    if (product.price && !this.state.promotionCoutdown) this.updatePromotionCoutdown();
  }

  updatePromotionCoutdown = async () => {
    const { product = {} } = this.props;
    if (product.price && !product.price.isContract && product.price.finalizedAt) {
      const promotionCoutdown = ProductsUtil.getPromotionCountdown(product.price);
      await this.setState({ promotionCoutdown });
      this.updateInterval = setTimeout(this.updatePromotionCoutdown, 1000);
    }
  }

  openCartMenu = () => this.props.headerRef && this.props.headerRef.current && this.props.headerRef.current.openCartMenu()

  addProductToCart = async () => {
    const { amount } = this.state;
    const { product = {}, isAuthenticated } = this.props;

    const isProductAmountInvalid = (!product.stock || product.stock === 0)
      && !this.props.allowSellSpotItensWithoutStock
      && product.isSpot
      && !product.price.isContract;

    if (!isAuthenticated) {
      await this.props.addItemCache(product.id, amount);
      this.openCartMenu();
    } else if (isProductAmountInvalid && !this.props.punchOut) {
      // this.props.openProductModal();
    } else if (product.id) {
      await this.props.addItem(product.id, product.clientCode, amount, product.code);
      this.openCartMenu();
    }
  }

  onClickViewProduct = (e) => {
    e.stopPropagation();

    try {
      const productsToSend = [];
      const productsPromotionToSend = [];
      const {
        clickLocation = '',
        clickPosition = 0,
        location = {},
        product,
      } = this.props;
      let listName = clickLocation;

      if (clickLocation === 'search') {
        const searchText = queryString.parse(location.search).text || '';
        listName = `${I18n.t('resultsSearch')}${searchText ? ` (${searchText})` : ''}`;

        productsToSend.push({
          name: product.name,
          id: product.code,
          price: `${product.price ? (product.price.value || 0) : 0}`,
          brand: product.brand ? product.brand.description : '',
          category: product.category ? product.category.name : '',
          list: listName,
          position: clickPosition + 1,
        });
      } else {
        productsToSend.push({
          name: product.name,
          id: product.code,
          price: `${product.price ? (product.price.value || 0) : 0}`,
          brand: product.brand ? product.brand.description : '',
          category: product.category ? product.category.name : '',
          list: clickLocation,
          position: clickPosition + 1,
        });
      }

      if (product.price && product.price.promo) {
        productsPromotionToSend.push({
          id: product.code,
          name: product.name,
          creative: listName,
          position: clickPosition + 1,
        });
      }

      tagManager.ecommerceClick(productsToSend);
      tagManager.ecommercePromotionClick(productsPromotionToSend);
    } catch (err) { }
  }

  productToFavorite = async () => {
    const { amount } = this.state;
    const { product = {}, isAuthenticated, favoritesItems } = this.props;
    const favorite = favoritesItems.find(fav => `${fav.productId}` === product.code);

    if (isAuthenticated) {
      if (favorite) {
        await this.props.favoritesRemoveItem(favorite.id, favorite.clientId);
      } else {
        await this.props.setProductsFavorites(product.id, product.code, product.clientCode, amount);
      }
    }
  }

  formatTotal = value => value && Number(value).toFixed(NumberHelper.countDecimals(this.state.multipleQuantity));

  handleAmount = async (value) => {
    const { amount } = this.state;

    const valDecCount = (amount.toString().split('.')[1] || '').length;
    const stepDecCount = (value.toString().split('.')[1] || '').length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    let valInt = parseInt(Number(amount).toFixed(decCount).replace('.', ''), 0);
    valInt = valInt <= 0 ? valInt * -1 : valInt;
    const stepInt = parseInt(Number(value).toFixed(decCount).replace('.', ''), 0);
    const qtd = ((valInt + stepInt) / (10 ** decCount));

    await this.handleSetAmount(qtd, false);
  };

  handleSetAmount = async (value, checkDecimals = true) => {
    const { product, allowSellSpotItensWithoutStock } = this.props;
    if (value === '' || value === '0' || (typeof value === 'number' && value <= 0)) {
      this.handleSetAmount(this.state.multipleQuantity || 1);
    } else if (!isNaN(value)) {
      const countedDecimals = NumberHelper.countDecimals(this.state.multipleQuantity);
      if (countedDecimals > 0 && checkDecimals) {
        value = Number(value.toString().replace(/\D+/g, ''))
          / (10 ** countedDecimals);
      }
      value = value < 0 ? 0 : value;

      if (value % 1 === 0 && countedDecimals === 0) {
        const modValue = value % product.multipleQuantity;
        if (modValue !== 0) value -= modValue;
      }

      await this.setState({ amount: value });
    }

    if (validator.isSpotProductAmountInvalid(value,
      product.stock, allowSellSpotItensWithoutStock, product.isSpot, product.price.isContract)) {
      this.setState({ amount: value });
    }
  };

  floatSafeModulus = (val, step) => {
    if (val && val !== '0') {
      const valDecCount = (val.toString().split('.')[1] || '').length;
      const stepDecCount = (step.toString().split('.')[1] || '').length;
      const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
      const valInt = parseInt(Number(val).toFixed(decCount).replace('.', ''), 0);
      const stepInt = parseInt(Number(step).toFixed(decCount).replace('.', ''), 0);
      return (((valInt % stepInt) + stepInt) % stepInt) / (10 ** decCount);
    }
    return 1;
  }

  renderProduct = ({
    amount,
    multipleQuantity,
    isAuthenticated,
    product,
    pricePermission,
    stockPermission,
    isContract,
    isAgreement,
    isListPage = true,
    uniqId,
    styleFavorite,
    portfolioGreen,
  }) => {
    const aboutAndPrice = null;

    const productComponent = (
      <div id="productModalListMain" className="product">
        <Link to={ProductsUtil.getUrl(product)} className="p-link">
          <span className="box-image">
            <span
              className="image"
              style={{
                backgroundImage: `url(${
                  product.image || '/images/product-image-placeholder.png'
                })`,
              }}
            />
          </span>

          {product.descriptionGreen && (
            <div className="cardItemGreenIcon">
              <div
                className="greenProductsIconeSize"
                style={{ display: 'block' }}
              >
                <Tooltip
                  disabled={!product.descriptionGreen}
                  trigger="mouseenter"
                  position="top"
                  style={{ display: 'block' }}
                  html={(
                    <div>
                      <p>{product.descriptionGreen}</p>
                    </div>
                    )}
                >
                  <svg className="greenProductsIconeSize">
                    <image
                      className="greenProductsIconeSize"
                      href={`${
                        portfolioGreen
                          || '/images/product-image-placeholder.png'
                      }`}
                    />
                  </svg>
                </Tooltip>
              </div>
            </div>
          )}

          <div className="productDescription">
            <div>
              <span className="description_product">{product.name}</span>
            </div>

            {pricePermission && (
            <div
              className={`productPrice${
                !product.price.hasPrice ? 'withoutProductPrice' : ''
              }`}
            >
              <span className="price">
                <FinalPriceComponent price={product.price} />
              </span>
            </div>
            )}

            {stockPermission && !!product.stock
              && (<span className="stock">{`${I18n.t('productStock')}: ${ProductsUtil.getStockAvailable(product.stock)}`}</span>)
            }
          </div>

          {isAgreement && (
            <span className="detail acordo tagProduct">
              {I18n.t('agreement')}
            </span>
          )}

          {isContract && (
            <span className="detail contrato tagProduct">
              {I18n.t('contract')}
            </span>
          )}

          <span className="detail">{I18n.t('visualizeDetail')}</span>
        </Link>

        <div id="productModalListFooter" className="p-footer">
          <div className="less">
            <button
              className="add__less"
              type="button"
              onClick={() => this.handleAmount(-multipleQuantity)}
            >
                -
            </button>
          </div>
          <div className="qnt">
            <input
              className="add__qnt"
              type="tel"
              onChange={e => this.modifyQuantityOfProducts(e.target.value)}
              value={this.formatTotal(amount) || '0'}
            />
          </div>
          <div className="more">
            <button
              className="add__more"
              type="button"
              onClick={() => this.handleAmount(+multipleQuantity)}
            >
                +
            </button>
          </div>
          <div className="cart">
            <a onClick={this.addProductToCart}>
              <svg className="icon icon-cart">
                <use xlinkHref="#icon-cart" />
              </svg>
            </a>
          </div>
          {isAuthenticated ? (
            <div
              className="view"
              id="favorite"
              onClick={this.productToFavorite}
            >
              <FontAwesomeIcon
                icon={this.IconFavorite[styleFavorite]}
                id="icon-favorite"
                color="#27348b"
                className="fa-2x"
              />
            </div>
          ) : (
            <div className="view">
              <Link to={ProductsUtil.getUrl(product)}>
                <svg className="icon icon-view">
                  <use xlinkHref="#icon-view" />
                </svg>
              </Link>
            </div>
          )}
        </div>
      </div>
    );

    if (isListPage) {
      return (
        <div className="product-list">
          <div className="product-list-header">
            <span
              className="image-list"
              style={{ backgroundImage: `url(${product.image || '/images/product-image-placeholder.png'})` }}
            />
            <span className="name-list">{product.name}</span>
            <span className="seal-list">
              {isContract && (
                <span className="seal contrato">{I18n.t('contract')}</span>
              )}
              {isAgreement && (
                <span className="seal acordo">{I18n.t('agreement')}</span>
              )}
            </span>
            {stockPermission && !!product.stock
              && (<span className="stock-list">{`${I18n.t('productStock')}: ${ProductsUtil.getStockAvailable(product.stock)}`}</span>)
            }
            {pricePermission && (
              <span className="price-list"><FinalPriceComponent price={product.price} /></span>
            )}
            {uniqId && <AddToCartComponent uniqId={uniqId} text={I18n.t('productCartAdd')} addProductToCart={this.addProductToCart} />}
          </div>
          {productComponent}
        </div>
      );
    }

    return productComponent;
  }

  render() {
    const {
      promotionCoutdown, amount, multipleQuantity,
    } = this.state;
    const {
      isAuthenticated, product = {}, cartPermission, pricePermission, portfolioGreen,
      stockPermission, allowSellSpotItensWithoutStock, orderType, isSearchPage, favoritesItems,
    } = this.props;

    const isContract = (product.price && product.price.isContract && product.price.type === 'contract');
    const isAgreement = (product.price && product.price.isContract && product.price.type === 'agreement');
    const isDiscount = (product.price && !product.price.isContract && product.price.discount);
    const isWithoutStock = (product.isSpot && product.price && !product.price.isContract && !product.stock);
    const isWithoutStockAllowSell = (product.isSpot && product.price && !product.price.isContract
      && !allowSellSpotItensWithoutStock && !product.stock);
    const isContactUs = (!product.stock && product.price && product.price.contactUs);
    const showAddToCart = ((isAuthenticated && cartPermission && product.price && product.price.hasPrice) || (!isAuthenticated))
      && (!isContactUs && !isWithoutStockAllowSell);
    const showOldValue = (pricePermission && product.price && !product.price.isContract && product.price.oldValue);
    const isListPage = orderType === 'list' && isSearchPage;
    const uniqId = showAddToCart && this.props.uniqId;

    const favoriteBool = favoritesItems.find(fav => `${fav.productId}` === product.code);
    const styleFavorite = favoriteBool ? 'faSolidStar' : 'faRegularStar';

    return this.renderProduct({
      promotionCoutdown,
      amount,
      multipleQuantity,
      isAuthenticated,
      product,
      cartPermission,
      pricePermission,
      stockPermission,
      allowSellSpotItensWithoutStock,
      isContract,
      isAgreement,
      isDiscount,
      isWithoutStock,
      isWithoutStockAllowSell,
      isContactUs,
      showAddToCart,
      showOldValue,
      isListPage,
      uniqId,
      styleFavorite,
      portfolioGreen,
    });
  }
}

const mapStateToProps = state => ({
  isAuthenticated: state.auth.authenticated,
  cartPermission: state.contracts.selected && state.contracts.selected.cartPermission,
  pricePermission: state.contracts.selected && state.contracts.selected.pricePermission,
  stockPermission: !state.contracts.selected || (state.contracts.selected && state.contracts.selected.stockPermission),
  allowSellSpotItensWithoutStock: state.contracts.selected
    && state.contracts.selected.clientDetails.allowSellSpotItensWithoutStock,
  punchOut: state.punchOut,
  orderType: state.products.orderType,
  favoritesItems: state.favorites.items,
  portfolioGreen: state.settings.portfolioGreen,
});

const mapDispatchToProps = dispatch => ({
  addItem: (productId, productClientCode, amount, productCode) => dispatch(cartAddItem(productId, productClientCode, amount, undefined, undefined, productCode)),
  addItemCache: (productId, amount) => dispatch(cartAddItemCache(productId, amount)),
  setProductsFavorites: (productId, productCode, productClientCode, quantity) => dispatch(setProductsFavorites(productId, productCode, productClientCode, quantity)),
  favoritesRemoveItem: (productId, clientId) => dispatch(favoritesRemoveItem(productId, clientId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductItem);
